import Divider from "../divider";
import React from "react";
import "./summary-page-sections.scss";
import ExternalLink from "../external_link";
import { If } from "react-extras";
import isEmpty from "lodash/isEmpty";

export const SummaryPageSectionWrapper = ({ title, children, pageNumber, updatePage }) => {
  return (
    <div className={"summary-page-section-wrapper m-bs"}>
      <div className={"flex-row-container"}>
        <h6 className="bold section-title">{title}</h6>
        <div className="flex-1" />
        <If condition={!!updatePage}>
          <button className="fake-link" onClick={() => updatePage(pageNumber)}>
            Edit
          </button>
        </If>
      </div>
      <Divider marginTop={24} marginBottom={14} />
      {children}
    </div>
  );
};
export const SummaryPageInfo = ({ title, text, newline, noColon }) => (
  <div className="m-bxs">
    <span className="bold">
      {title}
      {!noColon ? ":" : ""}{" "}
    </span>
    {newline && <br />}
    {text}
  </div>
);

export const CampaignDetailsSummaryPageInfo = ({ campaign }) => {
  if (isEmpty(campaign)) return null;

  return (
    <>
      <SummaryPageInfo title={"Campaign Name*"} text={campaign.name} />
      <SummaryPageInfo title={"Brand Name*"} text={campaign.brandName} />
      <SummaryPageInfo title={"Product or Service*"} text={campaign.productName} />
      <SummaryPageInfo title={"Product Description*"} text={campaign.productDescription} newline />
      <SummaryPageInfo
        title={"Website*"}
        text={
          <ExternalLink to={campaign.website}>
            <span className="bold">{campaign.website}</span>
          </ExternalLink>
        }
      />
      <SummaryPageInfo title={"Campaign Goals*"} text={campaign.goal} newline />
    </>
  );
};
